export default function ShiftStats({ stats }) {
  return (
    <div style={styles.wrap}>
      <span style={styles.stat}>📦 {stats.sales_count} чеків</span>
      <span style={styles.stat}>💵 {parseFloat(stats.total || 0).toFixed(2)} ₴</span>
    </div>
  );
}

const styles = {
  wrap: { display:'flex', gap:'10px' },
  stat: { color:'#9a8a6e', fontSize:'13px', background:'#38301f', padding:'4px 12px', borderRadius:'12px' },
};
